module.exports = __webpack_public_path__ + "img/company-honor-TPD-20240411.ec4d3852.jpg";